import React from 'react';
import { TMedicationItem } from 'types/common';
import { getProviderPrescriptionMedicationList } from 'api/common';
import { getUserId } from 'utils/localstore';

let globalData: TMedicationItem[] = [];

const useProviderPrescriptionMedication = (clientId?: number): [TMedicationItem[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TMedicationItem[]>(globalData);
    const fetchData = async () => {
        if (loading) return;
        try {
            setLoading(true);
            const result = await getProviderPrescriptionMedicationList({
                providerId: getUserId(),
                clientId,
                size: 1000,
            });
            if (!result.error) {
                const resData = result?.data?.data?.list || [];
                globalData = resData;
                setItems(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        if (clientId) {
            fetchData();
        }
    }, [clientId]);

    return [items, loading, fetchData];
};

export default useProviderPrescriptionMedication;
